import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeometryHelper {
  isCoordinateEmpty(coordinate?: string): boolean {
    return Number.isNaN(parseFloat(coordinate));
  }
}
